import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';

/** Reemplazar por la URL real de checkout en ImpulTienda. */
const CHECKOUT_URL = 'https://baseball-practice-ready.impultienda.ar/checkout';
const included = ['6 complete volumes', '5 instant-use bonuses', '300+ pages, print-ready', '37 ready-to-run practices', 'Scaled for ages 5-6 through 13+', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ice text-ink" data-id="element-166" data-mp="1rt8966ynet7x">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-167" data-mp="25t0t9jfo6b6x">
        <div className="text-center" data-id="element-168" data-mp="20slimzmrvhsn">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-169" data-mp="20rjubtgqwysz">
            Complete package
          </p>
          <h2 id="pricing-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-170" data-mp="3h97o64oy7cvh">
            Everything you need for the whole season
          </h2>
        </div>

        <div className="clip-corner mt-8 overflow-hidden rounded-3xl border border-ice-dark bg-white shadow-card" data-id="element-171" data-mp="4s4bhb4kgrhw">
          <div className="bg-navy px-5 py-5 text-center" data-id="element-172" data-mp="9ss05q5bow8y">
            <h3 className="font-display text-xl uppercase tracking-wide text-white sm:text-2xl" data-id="element-173" data-mp="erv6rf0ybaj1">
              Baseball Practice Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold text-gold-hover" data-id="element-174" data-mp="3d74i4g4n6xcl">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-175" data-mp="3n6vaoc9n72a1">
            <img src="https://cdn.magicpatterns.com/uploads/hiSNvZtmrkg7LvEyCiMU5M/hf_20260917_195831_857e49cb-d5cd-44ff-a2f7-c7381e31565f_(1).png" alt="Baseball Practice Ready complete package: six volumes with the system on desktop, tablet and phone" width={1200} height={886} loading="lazy" className="mx-auto w-full max-w-lg" data-id="element-176" data-mp="3n5u1kdc6spuy" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-177" data-mp="2mhrt9p627i3n">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-178" data-mp="316el2qcvi2br">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-179" data-mp="318r313imscot">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-180" data-mp="28hqxgo4nj0v1" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-181" data-mp="2ihhp8i1tv1rf">
              <p className="text-[13px] text-ink-soft" data-id="element-182" data-mp="2dgai8l7ie6lt">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-183" data-mp="3tuaf1nb25g4u">$90 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-184" data-mp="3ox1tdcqpatyu">
                <span className="mt-2.5 font-display text-3xl" data-id="element-185" data-mp="ana6bsdrwnn">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-186" data-mp="cgl43a1131g">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-187" data-mp="3nfczipwlep6d">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-188" data-mp="3rhgcjiywu1tr">
                <span className="rounded border border-gold bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-189" data-mp="j0lhuqs9nnqr">
                  Save $63
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-190" data-mp="a9356puj3q2f">
                  One-time payment
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-191" data-mp="11z7jq7vlxivq">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-192" data-mp="3f8juua2lyf4p">
                Get Baseball Practice Ready now — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-193" data-mp="3aas43jdp8z23">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-194" data-mp="31897vi4f5kot">
                <li className="flex items-center gap-1.5" data-id="element-195" data-mp="1rkllxem9ge4">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-196" data-mp="3syx72omj8fzu" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-197" data-mp="3k6lditw4gcfn">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-198" data-mp="3k63jm3wxmaaw" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-199" data-mp="fqu3r2mdukkq">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-200" data-mp="1yfog3lhryu9v" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-201" data-mp="27i63i3961syg">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}